import React from 'react';
import { FlexiflowComponent } from '@flexiflow-ui-kit/system';
import styled from 'styled-components';
import { Menu, MenuButton, MenuList, MenuItem } from '@reach/menu-button';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var Dropdown = styled(Menu)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n"])), function (p) {
  return p.theme.predefinedCss.borderBoxChildren;
});
var DropdownButton$1 = styled(MenuButton)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  cursor: ", ";\n  color: ", ";\n  border-radius: 3px;\n  padding: 4px 16px;\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: 14px;\n  line-height: 24px;\n  width: auto;\n  height: 32px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n"])), function (p) {
  return p.theme.palette.gray['100'];
}, function (p) {
  return p.disabled ? 'not-allowed' : "pointer";
}, function (p) {
  return p.disabled ? p.theme.palette.gray['600'] : p.theme.palette.black;
}, function (p) {
  return p.theme.fonts.text;
}, function (p) {
  return p.theme.fontWeights.semiBold;
});
var DropdownList = styled(MenuList)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));\n  border-radius: 3px;\n  width: auto;\n  height: auto;\n  margin-top: 4px;\n  padding: 4px 0;\n"])), function (p) {
  return p.theme.palette.white;
});
var DropdownItem = styled(MenuItem)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  min-height: 32px;\n  padding: 6px 16px;\n  font-size: 14px;\n  line-height: 20px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  color: ", ";\n  background-color: ", ";\n\n  :hover {\n    background-color: ", ";\n    cursor: ", ";\n  }\n"])), function (p) {
  return p.$disabled && p.theme.palette.gray['500'] || p.$isRed && p.theme.palette.red['700'] || p.theme.palette.black;
}, function (p) {
  return p.theme.palette.white;
}, function (p) {
  return p.theme.palette.gray['100'];
}, function (p) {
  return p.$disabled ? 'not-allowed' : 'pointer';
});

function DropdownButton(_ref) {
  var options = _ref.options,
      children = _ref.children,
      className = _ref.className,
      _ref$disabled = _ref.disabled,
      disabledDropdown = _ref$disabled === void 0 ? false : _ref$disabled;
  return /*#__PURE__*/React.createElement(FlexiflowComponent, null, /*#__PURE__*/React.createElement(Dropdown, null, /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(DropdownButton$1, {
    disabled: disabledDropdown,
    className: "dropdown__button"
  }, children), /*#__PURE__*/React.createElement(DropdownList, {
    className: "dropdown__list"
  }, options.map(function (_ref2, index) {
    var label = _ref2.label,
        onSelect = _ref2.onSelect,
        red = _ref2.red,
        disabled = _ref2.disabled;
    return /*#__PURE__*/React.createElement(DropdownItem, {
      key: index,
      onSelect: onSelect,
      $isRed: red,
      $disabled: disabled,
      disabled: disabled,
      className: "menu__item"
    }, label);
  })))));
}

export { DropdownButton };
